import {    UserMessageTypeEnum,
            BotMessageTypeEnum,
            ErrorMessageTypeEnum,
            MessageOriginEnum,
            ConfigService,
            IAttachment }                      from '../../..';

/**
* Defines a message sent or received. The origin could be the user or the BotServer.
* The attachments are organized by type in a Map to get easier their usage into the 
* component template.
*/
export class MessageEntity {
    public msgId!: string;
    public origin!: MessageOriginEnum;

    /**
    * Constructor.
    * 
    * @param watermark - The associated watermark
    * @param type - The message type it could be the UserMessageTypeEnum or BotMessageTypeEnum value
    * @param from - The sender identifier
    * @param conversationId - The conversation identifier
    * @param text - The message content
    * @param time - The message timestamp
    * @param hasOtherResponses - Indicates whetner or not this message has other possible responses
    * @param attachments - The associated attachments
    * @param displayableResponses - The displayable responses list including main answer and the other responses
    */
    constructor(public watermark: number,
                public type: UserMessageTypeEnum | BotMessageTypeEnum | ErrorMessageTypeEnum,
                public from: string,
                public conversationId: string,
                public text: string,
                public time: string,
                public hasOtherResponses: boolean = false,
                public additionalAnswerIdx: number = 0,
                public attachments?: Map<number, IAttachment[]>,
                public displayableResponses?: MessageEntity[]) {

                this.msgId = watermark >= 0 ? `${conversationId}-${watermark}_${additionalAnswerIdx}` 
                                            : `${conversationId}-intro`;
                
                this.origin = (from === ConfigService.getBotUserOrigin()) ? MessageOriginEnum.USER 
                                                                          : MessageOriginEnum.BOT;

                this.attachments = attachments ? attachments : new Map<number, IAttachment[]>();
            }
}
